import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="pulse-loader-container">
      <div className="pulse-circle"></div>
      <div className="pulse-text">Loading...</div>
    </div>
  );
};

export default Loader;